import React from 'react';
import memoize from 'memoize-one';
import { noop, sortBy, compact } from 'lodash';
import { parseRawCategory } from '@components/filter/components/utils';
import { MinusSquareOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Button, Collapse, Spin, Tabs } from 'antd';
import FilterCell from './FilterCell';
import styles from './index.less';
import containerStyles from '../FilterContainer.less';

const createFilterMap = memoize((filters) => {
  const filtersMap = new Map();
  filtersMap.set('ALL', new Map());
  filters.forEach((filter) => {
    const { category: cat, subcategory: subCat } = parseRawCategory(filter.category);
    let catMap = filtersMap.get(cat);
    if (!catMap) {
      catMap = new Map();
      filtersMap.set(cat, catMap);
    }
    let subList = catMap.get(subCat);
    if (subList) {
      subList.push(filter);
    } else {
      subList = [filter];
      catMap.set(subCat, subList);
    }
  });
  return filtersMap;
});

class SavedFilterPanel extends React.PureComponent {
  render() {
    const { filters, selectedFilters } = this.props;
    if (filters.length === 0) { return 'No saved filters'; }

    const selectedFilterIds = compact(selectedFilters.map(f => f.fid));
    const filtersMap = createFilterMap(filters);
    const tabs = this.renderCategoryTabs(filtersMap, selectedFilterIds);

    return (
      <>
        <Tabs className={styles.savedFilterPanel} tabPosition="left">
          {tabs}
        </Tabs>
        {this.renderButtons()}
      </>
    );
  }

  onCheckFilterCell = filter => (() => {
    const { onCheck } = this.props;
    onCheck(filter);
  });

  renderButtons = () => {
    const { onCancel, onApply, selectedFilters } = this.props;
    const classNames = `${containerStyles.buttons} ${styles.buttonRow}`;
    return (
      <div className={classNames}>
        <Button className={containerStyles.leftBtn} onClick={onCancel}>Cancel</Button>
        <Button disabled={selectedFilters.length === 0} className={containerStyles.rightBtn} type="primary" onClick={onApply}>Apply</Button>
      </div>
    );
  };

  renderCategoryTabs = (filtersMap, selectedFilterIds) => {
    const sortedCategories = Array.from(filtersMap.keys()).sort();
    const tabs = sortedCategories.map((name) => {
      const subMap = filtersMap.get(name);
      if (name === 'ALL') { return null; }
      return this.renderSubcategories(name, subMap, selectedFilterIds);
    });
    return tabs;
  };

  onCollapse = ({ isActive }) => (isActive ? <MinusSquareOutlined /> : <PlusSquareOutlined />);

  renderSubcategories = (name, subMap, selectedFilterIds) => (
    <Tabs.TabPane tab={name} key={name}>
      <Collapse bordered={false} expandIcon={this.onCollapse}>
        {this.renderSubcategory(subMap, selectedFilterIds)}
      </Collapse>
    </Tabs.TabPane>
  );

  renderSubcategory = (subMap, selectedFilterIds) => {
    const { allowMultiSelection } = this.props;
    const sortedKeys = Array.from(subMap.keys()).sort();
    const subs = sortedKeys.map((subName) => {
      const subList = subMap.get(subName);
      return (
        <Collapse.Panel header={subName} key={subName} className={styles.subPanel}>
          {sortBy(subList, ['name']).map(filter => (
            <FilterCell
              key={filter.fid}
              filter={filter}
              checked={selectedFilterIds.includes(filter.fid)}
              onChange={this.onCheckFilterCell(filter)}
              isCheckbox={allowMultiSelection}
            />
          ))}
        </Collapse.Panel>
      );
    });
    return subs;
  }
}

SavedFilterPanel.defaultProps = {
  filters: [],
  onApply: noop,
  onCancel: noop,
  onCheck: noop,
  selectedFilters: [],
  allowMultiSelection: false,
};

export default SavedFilterPanel;
